import a from "./index967.js";
function r(t) {
  return a(this, t).get(t);
}
export {
  r as default
};
